<template>
  <b-modal
    id="modal-add-child-works"
    :title="editData && editData.id ? $t('edit_job_type') :$t('add_job_type')"
    cancel-variant="outline-secondary"
    :ok-title="editData && editData.id ? $t('edit') : $t('general.add')"
    ok-variant="success"
    :cancel-title="$t('general.close')"
    centered
    no-close-on-backdrop
    @show="onShowModal"
    @ok.prevent="onSubmit"
  >
    <b-form>
      <validation-observer ref="addChildWorksValidations">

        <b-tabs content-class="pt-1" fill>
          <b-tab active :title="$t('reference.name') + ' uz'">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name')"
                rules="required"
              >
                <b-form-input v-model="title.uz" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('reference.name') + ' ru'">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name')"
                rules="required"
              >
                <b-form-input v-model="title.ru" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>


        <b-form-group :label="$t('reference.unit')">
          <validation-provider
            #default="{ errors }"
            :name="$t('reference.unit')"
            rules="required"
          >
            <v-select
              v-model="unity"
              label="short_title"
              :reduce="(p) => p.id"
              :options="GET_UNITS.results"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>


        <!-- <b-form-group :label="$t('namee')">
          <validation-provider
            #default="{ errors }"
            :name="$t('reference.name')"
            rules="required"
          >
            <b-form-input v-model="title" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group> -->

      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormCheckbox,
  BTable,
  BRow,
  BCol,
  BBadge,
  BTabs,
  BTab,
  BFormInput,
  BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import vSelect from "vue-select";
import { required } from "@core/utils/validations/validations";
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
  components: {
    BModal,
    BForm,
    BFormCheckbox,
    BTable,
    BRow,
    BCol,
    BBadge,
    AppSearchInput,
    BFormInput,
    BTabs,
    BTab,
    BFormGroup,
    vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    editData: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      filtered: {
        search: null,
      },
      title: {ru: '', uz: ''},
      unity: '',
      // ===============  PRIMARY_DATA_SECTION END ===============




      // ===============  OTHERS_SECTION START ===============
    
      // ===============  OTHERS_SECTION END ===============
    }
  },

  computed: {
    // ...mapGetters('obectsWarehouse', ['GET_WAREHOUSE']),
    ...mapGetters("characterUnits", ["GET_UNITS"]),



  },
  async mounted(){
    // await this.FETCH_UNITS({page_size: 1000})
  },

  methods: {
    // ...mapActions('obectsWarehouse', ['UPDATE_CHECKBOX', 'FETCH_WAREHOUSE_LEFT_TABLE']),
    ...mapActions("brigadeWorks", [
      "CREATE_BRIGADE_WORKS",
      "UPDATE_PUT_BRIGADE_WORKS",
    ]),
    ...mapActions("characterUnits", ["FETCH_UNITS"]),




    // ===============  ON_SHOW_SECTION START ===============
    onShowModal() {
      this.title = {ru: '', uz: ''}
      if (!this.editData) {
        return;
      }
      if (typeof this.editData === "object" &&this.editData !== null) {
        this.title = this.editData && this.editData.title ? this.editData.title : {ru: '', uz: ''};
      }
    },
    // ===============  ON_SHOW_SECTION END ===============





     // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      
      const success = await this.$refs.addChildWorksValidations.validate();
      if (!success){
        this.$_errToast({message: this.$t('all_fields_are_required')});
        return;
      }

      const req = {
        id: this.editData && this.editData.id ? this.editData.id : null,
        title: this.title,
        unity: this.unity,
      };
      

      (this.editData && this.editData.id
        ? this.UPDATE_PUT_BRIGADE_WORKS({ id: req.id, title: req.title, unity: req.unity})
        : this.CREATE_BRIGADE_WORKS({title: req.title, unity: req.unity, category: Number(this.$route.query.category),})
      )
        .then(() => {
          this.$emit("save");
          this.$_okToast().then(() => {
            this.title = {ru: '', uz: ''},
            this.$bvModal.hide("modal-add-child-works");
          });
        })
        .catch((err) => {
          console.log(err.response)
          if(err && err.response && err.response.status && err.response.status == 400 && err.response.data[0]){
            this.$_errToast({message: err.response.data[0]})
          }
        });
    },
    // ===============  ON_SUBMIT_SECTION END ===============





    
  },
}
</script>
